import { useTranslation } from '@lt/localization';
import React from 'react';
import fadeInAndOut from 'src/components/animations/SkeletonFadeInAndOut';
import styled from 'styled-components';
import type { PropsFromRedux } from '.';
import SkeletonDetails from '../SkeletonDetails/SkeletonDetails';
import LoadingFlightSticks from './components/LoadingFlightSticks';

const FlightsSkeleton = (props: PropsFromRedux) => {
  const {
    flightData: { to, back },
    isMobile,
  } = props;
  const { t } = useTranslation();
  const loadingFlightsText = t('checkout.flight.skeletonText');
  return (
    <StyledContainer $isMobile={isMobile}>
      <StyledSkeletonDetails isMobile={isMobile} to={to} back={back} />
      <LoadingFlightSticks loadingFlightsText={loadingFlightsText} />
    </StyledContainer>
  );
};

const StyledContainer = styled.div<{ $isMobile: boolean }>`
  display: flex;
  ${(props) => props.$isMobile && `flex-direction: column;`}
  align-items: stretch;
  align-self: stretch;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0px 10px 15px 0px rgba(216, 214, 204, 0.9),
    0px 1px 2px 0px rgba(210, 208, 197, 0.9);
  & + & {
    margin-top: 16px;
  }
  animation: ${fadeInAndOut} 1.2s ease-in-out infinite;
`;

const StyledSkeletonDetails = styled(SkeletonDetails)<{ isMobile: boolean }>`
  padding: 8px 8px;
  background: #fff;
  ${({ isMobile }) => !isMobile && `margin-top: 0;`}
`;

export default FlightsSkeleton;
